import axios from "axios";
import { API_URL } from "../config/config";

export const updateProfile = async (userId: string, data: any, type: string) => {
    const token = localStorage.getItem('token');

    let url = "";
    if (type === 'MANAGER' || type === 'EMPLOYEE') {
        url = `${API_URL}/worker/${userId}`;
    } else {
        url = `${API_URL}/admin/${userId}`;
    }

    const response = await axios.put(url, data, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    });

    return response.data;
};

